import React, { useState, useRef, useEffect } from 'react'


import Icons from '../../components/icons';
import * as Img from '../../components/Img';

import useApi from '../../utility/apiCall';
import API_URL from '../../config/config';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth, getLoggedInUserData } from '../../context/AuthContext';
import FlashMessage from '../../components/FlashMessage';
import Button from 'react-bootstrap/Button';
import EmptyBox from '../../components/EmptyBox';
import Loaders from '../../components/Loader';
import CloseIcon from '../../components/CloseIcon';


import Breadcrumb from '../../components/Breadcrumb'

// Common Field
import Input from '../../components/commonfield/Input'
import SelectInput from '../../components/commonfield/SelectInput'
import PaymentMethodItem from '../PageChallenge/PaymentMethodItem'
import Alert from '../../components/Alert';




export default function PagePayoutsRequest() {
  //Auth related var

  const { apiCall } = useApi();
  const navigate = useNavigate();
  const { state, dispatch } = useAuth();
  const token = state.token || '';
  const isInitialMount = useRef(true);

  const { id } = useParams();

  //Loader
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [requestSubmitError, setRequestSubmitError] = useState(false);
  const [requestSubmitErrorMsg, setRequestSubmitErrorMsg] = useState(false);
  const [requestSubmitSuccess, setRequestSubmitSuccsess] = useState(false);
  const [requestSubmitSuccessMsg, setRequestSubmitSuccessMsg] = useState(false);

  const [userWalletAccountList, setUserWalletAccountList] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState(null);
  const [paymentMethodName, setPaymentMethodName] = useState('');
  const [paymentMethodId, setPaymentMethodId] = useState('');


  const [inPaymentMethod, setInPaymentMethod] = useState(0);
  const [amount, setAmount] = useState('');
  const [accountName, setAccountName] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [ifscCode, setIfscCode] = useState('');
  const [bankName, setBankName] = useState('');
  const [addressID, setAddressID] = useState('');
  const [selectedUserWalletID, setSelectedUserWalletID] = useState('');
  const [affilateBalance, setAffilateBalance] = useState(0);
  const [accountType, setAccountTypeList] = useState([]);
  const [stepFilterValue, setStepFilterValue] = useState('all');


  const [tab, setTab] = useState('step1');
  const handleStepClick = (stepId) => {
    if (stepId == 'step2') {
      setRequestSubmitError(false);
      if (selectedUserWalletID == '' && activeTab == 'trading_account') {
        setRequestSubmitError(true);
        setRequestSubmitErrorMsg('Please select user wallet account');

      } else {
        setRequestSubmitError(false);
        setTab(stepId)
        setInPaymentMethod(0);
      }
    } else {
      setTab("step1")
    }
    setPaymentMethodName('');
    setPaymentMethodId('');
    // setRequestSubmitError(false);
  };


  useEffect(() => {
    const fetchData = async () => {
      const loggedInUser = getLoggedInUserData();
      const isUserLoggedIn = !!loggedInUser;

      if (isUserLoggedIn) {
        if (loggedInUser.id && token) {
          try {
            // getIbRequestStatus();
            // const checkAffiliate = await checkAffiliateAvailable();
            const paymentMethod = await getPaymentMethods();
            const accountType = await getAccountTypeList();
            setDataLoaded(true);
            // console.log(tradeHistory);
            // Assuming getUserWalletGroupWise returns the data needed for wallets and walletGroups
          } catch (error) {
            console.error('Failed to fetch ib data:', error);
          }
        }
      }
    };

    if (isInitialMount.current) {
      isInitialMount.current = false;
      fetchData();
    }
  }, [token]);

  // const accountListGet = () => {
  //   const manualEntry = { value: 'all', name: 'All accounts' };
  //   const mappedData = accountType.map(item => ({
  //                         value: item.step,
  //                         name: item.step
  //                       }))
  //   return [manualEntry, ...mappedData];

  // };
  useEffect(() => {
    if (stepFilterValue != 'all') {
      getRealUserWalletAccount();
    }
  }, [stepFilterValue]);

  const getAccountTypeList = async () => {
    // Logic to get user wallet group-wise data
    try {
      const response = await apiCall(API_URL + 'get-account-type-list', {
        user_id: state.userData.id,
        status: 'active',
        token: token,
      });
      if (response.data.success == '0') {
        if (response.data.data.length > 0) {
          console.log('accountType', response.data.data);
          setAccountTypeList(response.data.data);
        } else {
          setAccountTypeList([]);
        }

      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const getRealUserWalletAccount = async () => {
    try {
      //setIsLoading(true);
      // console.log({id});
      const response = await apiCall(API_URL + 'get-real-user-wallet', {
        user_id: state.userData.id,
        stepFilterValue: stepFilterValue,
        token: token
      });
      if (response.data.success == '0') {
        console.log(response.data.data);
        setUserWalletAccountList(response.data.data);
        //   setDailySummaryTradingList(response.data.data.data)
        //   setTotalPagesDailySummary(response.data.data.last_page)
      }
      //setIsLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  const getAffilateBalance = async () => {
    try {
      setIsLoading(true);
      // console.log({id});
      const response = await apiCall(API_URL + 'get-affilate-balance', {
        user_id: state.userData.id,
        token: token
      });
      if (response.data.success == '0') {
        console.log('affilite', response.data.data);
        setAffilateBalance(response.data.data.amount);
        //   setDailySummaryTradingList(response.data.data.data)
        //   setTotalPagesDailySummary(response.data.data.last_page)
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const getPaymentMethods = async () => {
    // Logic to get user wallet group-wise data
    try {
      const response = await apiCall(API_URL + 'get-payment-methods', {
        user_id: state.userData.id,
        token: token,
        nopaginate: 1
      });
      if (response.data.success == '0') {
        setPaymentMethods(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const transformChartData = () => {
    // console.log('profitChartDataprofitChartDataprofitChartDataprofitChartData', profitChartData);
    return userWalletAccountList.map(item => ({
      value: item.id,
      name: "MT5 " + item.account_number
    }));
  };

  const Accounttype = transformChartData();

  const handleChange = () => {
  };

  const removeSpacesAndLowercase = (inputString) => {
    // Remove spaces using regex and convert to lowercase
    const processedString = inputString.replace(/\s+/g, '').toLowerCase();
    return processedString;
  };



  const handlePaymentMethodIdChange = (payment_method, method_name) => {
    setPaymentMethodId(payment_method);
    setInPaymentMethod(1)
    setPaymentMethodName(removeSpacesAndLowercase(method_name));
    // alert(removeSpacesAndLowercase(method_name))
  }

  const demo = () => {
  }

  // Effect to set the first item as active by default when accountType changes
  useEffect(() => {
    if (accountType && accountType.length > 0) {
      setStepFilterValue(accountType[0].id);
    }
  }, [accountType]);

  const onChageAmount = (value) => {
    setAmount(value);
    setErrors((prev) => ({ ...prev, amount: '' }));
  }
  const onChageAccountName = (value) => {
    setAccountName(value);
    setErrors((prev) => ({ ...prev, accountName: '' }));
  }
  const onChageAccountNumber = (value) => {
    setAccountNumber(value);
    setErrors((prev) => ({ ...prev, accountNumber: '' }));
  }
  const onChageIFSCCode = (value) => {
    setIfscCode(value);
    setErrors((prev) => ({ ...prev, ifscCode: '' }));
  }
  const onChageBankName = (value) => {
    setBankName(value);
    setErrors((prev) => ({ ...prev, bankName: '' }));
  }
  const onChageAddressID = (value) => {
    setAddressID(value);
    setErrors((prev) => ({ ...prev, addressID: '' }));
  }

  const validateAccountFields = () => {
    const newErrors = {};

    if (!amount && activeTab == 'affiliate') {
      newErrors.amount = 'Amount is required';
    }

    if (amount > affilateBalance && activeTab == 'affiliate') {
      newErrors.amount = 'Affliate balance is lower than you enter amount please check';
    }

    if (!accountName && paymentMethodName == "upi") {
      newErrors.accountName = 'Account Name is required';

    }

    if (!accountNumber && paymentMethodName == "upi") {
      newErrors.accountNumber = 'Account number is required';

    }

    if (!ifscCode && paymentMethodName == "upi") {
      newErrors.ifscCode = 'IFSC code is required';

    }

    if (!bankName && paymentMethodName == "upi") {
      newErrors.bankName = 'Bank name is required';

    }

    if (!addressID && paymentMethodName != "upi") {
      newErrors.addressID = 'Address ID is required';

    }

    // if (!selectedUserWalletID) {
    //   newErrors.setSelectedUserWalletID = 'Please select first your wallet account';

    // }

    return newErrors;
  };

  const handleUserWalletChange = (event) => {
    setSelectedUserWalletID(event.target.value);
    setErrors((prev) => ({ ...prev, selectedUserWalletID: '' }));
  }

  const handleAccountSubmit = async () => {
    if (kycStatus !== 'approved' && (!aadharFront || !aadharBack || !videoBlob)) {
      setTab('kyc_flow');
      setRequestSubmitError(true);
      setRequestSubmitErrorMsg("Please complete the KYC step before submitting.");
      return;
    }

    setIsLoading(true);
    setRequestSubmitError(false);
    setRequestSubmitSuccsess(false);
    const valErrors = validateAccountFields();
    if (Object.keys(valErrors).length === 0) {
      // Create a FormData object
      const formData = new FormData();

      formData.append('user_id', state.userData.id);
      formData.append('token', token);
      formData.append('amount', amount);
      formData.append('payment_method_id', paymentMethodId);
      formData.append('user_wallet_id', selectedUserWalletID);
      formData.append('payout_type', activeTab);
      
      // Add KYC files only if not already verified
      if (kycStatus !== 'approved') {
        formData.append('aadhar_front', aadharFront);
        formData.append('aadhar_back', aadharBack);
        formData.append('video_kyc', videoBlob, 'kyc_video.mp4');
      }

      if (paymentMethodName == "upi") {
        formData.append('account_holder_name', accountName);
        formData.append('account_number', accountNumber);
        formData.append('account_ifsc_code', ifscCode);
        formData.append('account_bank_name', bankName);
      }
      if (paymentMethodName != "upi") {
        formData.append('payment_wallet_address_id', addressID);
      }

      try {
        setIsLoading(true);
        setRequestSubmitSuccsess(false)
        setRequestSubmitError(false)
        apiCall(API_URL + 'create-request-of-payouts', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(response => {
            if (response.data.success == 0) {
              setIsLoading(false);
              setRequestSubmitSuccsess(true);
              setRequestSubmitSuccessMsg('Payout request added successfully');
              setTimeout(() => {
                navigate('/payouts');
              }, 2000);
            } else {
              setIsLoading(false);
              setRequestSubmitError(true)
              setRequestSubmitErrorMsg(response.data.data.error || response.data.message)
            }
          })
          .catch(error => {
            setIsLoading(false);
            setRequestSubmitError(true)
            setRequestSubmitErrorMsg(error.response?.data?.message || "An error occurred")
          });
      } catch (error) {
        setIsLoading(false);
      }
    } else {
      setErrors(valErrors);
      setTab('step3');
      setRequestSubmitError(false);
      setIsLoading(false);
    }
  };

  // const [isAffiliate, setAffiliate] = useState(1);
  // useEffect(() => {
  //   if(isAffiliate != 1){
  //     navigate('/home');
  //   }
  // },[isAffiliate])

  //  const checkAffiliateAvailable = async () => {
  //     try {
  //       // setIsLoading(true);
  //       // console.log({id});
  //       const response = await apiCall(API_URL +'check-affiliate-available', {
  //           user_id: state.userData.id,
  //           token: token
  //       });
  //       if (response.data.success == '0') {
  //         // console.log(response.data.data);
  //         setAffiliate(response.data.data);
  //         // setTotalPagesDailySummary(response.data.data.last_page)
  //       }
  //       // setIsLoading(false);
  //     } catch (error) {
  //         console.error('Error fetching data:', error);
  //     }
  //   };

  const [activeTab, setActiveTab] = useState('trading_account');
  const [kycStep, setKycStep] = useState('aadhar'); // 'aadhar', 'video', 'pending'
  const [aadharFront, setAadharFront] = useState(null);
  const [aadharBack, setAadharBack] = useState(null);
  const [aadharFrontPreview, setAadharFrontPreview] = useState(null);
  const [aadharBackPreview, setAadharBackPreview] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const [videoBlob, setVideoBlob] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const [recordingTime, setRecordingTime] = useState(0);
  const [showVideoPlaceholder, setShowVideoPlaceholder] = useState(true);
  const [recordedChunks, setRecordedChunks] = useState([]);
  const mediaRecorderRef = useRef(null);
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const timerRef = useRef(null);
  const [kycStatus, setKycStatus] = useState('not_submitted');

  const fetchKycStatus = async () => {
    try {
      const response = await apiCall(API_URL + 'get-profile', {
        user_id: state.userData.id,
        token: token,
      });
      if (response.data.success == '0') {
        // Use is_kyc_verified from the API response
        const isVerified = response.data.data.is_kyc_verified || false;
        setKycStatus(isVerified ? 'approved' : 'not_submitted');
        
        // Update context if status changed
        if (isVerified !== (state.userData?.is_kyc_verified || false)) {
          dispatch({ type: 'LOGIN', payload: { user: response.data.data, token: token } });
        }
      }
    } catch (error) {
      console.error('Error fetching KYC status:', error);
    }
  };

  useEffect(() => {
    if (state.userData?.id) {
      fetchKycStatus();
    }
  }, [state.userData?.id]);

  useEffect(() => {
    return () => {
      stopCamera();
      if (videoUrl) URL.revokeObjectURL(videoUrl);
      if (aadharFrontPreview) URL.revokeObjectURL(aadharFrontPreview);
      if (aadharBackPreview) URL.revokeObjectURL(aadharBackPreview);
    };
  }, [videoUrl, aadharFrontPreview, aadharBackPreview]);

  const handleTabClick = (tab) => {

    if (tab == 'affiliate') {
      getAffilateBalance();
    }
    setActiveTab(tab);
  };

  const handleAadharFrontChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAadharFront(file);
      setAadharFrontPreview(URL.createObjectURL(file));
    }
  };

  const handleAadharBackChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAadharBack(file);
      setAadharBackPreview(URL.createObjectURL(file));
    }
  };

  useEffect(() => {
    if (kycStep === 'video' && tab === 'kyc_flow' && !videoBlob) {
      startCamera();
    } else {
      stopCamera();
    }
    
    return () => {
      stopCamera();
    };
  }, [kycStep, tab, videoBlob]);

  // Sync stream with video element whenever recording state changes
  useEffect(() => {
    if (videoRef.current && streamRef.current && !videoBlob) {
      const videoElement = videoRef.current;
      if (videoElement.srcObject !== streamRef.current) {
        videoElement.srcObject = streamRef.current;
      }
      // Ensure it's playing
      if (videoElement.paused) {
        videoElement.play().catch(e => console.error("Error playing video in sync:", e));
      }
    }
  }, [isRecording, videoBlob, kycStep, tab]);

  const startCamera = async () => {
    try {
      // Don't request again if we already have a stream
      if (streamRef.current && streamRef.current.active) {
        if (videoRef.current) {
          const videoElement = videoRef.current;
          videoElement.srcObject = streamRef.current;
          videoElement.onloadedmetadata = () => {
             videoElement.play().catch(e => console.error("Error playing existing stream:", e));
          };
          videoElement.play().catch(e => {});
        }
        return;
      }

      // First, try to get a list of video devices
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(device => device.kind === 'videoinput');

      // Try to find a device that doesn't contain "obs" in its label
      let preferredDeviceId = null;
      if (videoDevices.length > 1) {
        const realCameras = videoDevices.filter(device =>
          !device.label.toLowerCase().includes('obs') &&
          !device.label.toLowerCase().includes('virtual')
        );
        if (realCameras.length > 0) {
          preferredDeviceId = realCameras[0].deviceId;
        }
      }

      const constraints = {
        video: preferredDeviceId ? { deviceId: { exact: preferredDeviceId } } : {
          width: { ideal: 1280 },
          height: { ideal: 720 },
          facingMode: "user"
        },
        audio: true
      };

      let stream;
      try {
        stream = await navigator.mediaDevices.getUserMedia(constraints);
      } catch (audioErr) {
        console.warn("Audio access failed, trying video only:", audioErr);
        stream = await navigator.mediaDevices.getUserMedia({ 
          video: constraints.video, 
          audio: false 
        });
      }
      
      streamRef.current = stream;
      setShowVideoPlaceholder(false);
      
      if (videoRef.current) {
        const videoElement = videoRef.current;
        videoElement.srcObject = stream;
        videoElement.onloadedmetadata = () => {
          if (videoRef.current) {
            videoElement.play().then(() => {
              console.log("Camera playing successfully");
            }).catch(e => {
              console.error("Error playing video:", e);
              if (videoRef.current) {
                videoElement.play();
              }
            });
          }
        };
        videoElement.play().catch(e => {});
      }
    } catch (err) {
      console.error("Error accessing camera:", err);
      setRequestSubmitError(true);
      setRequestSubmitErrorMsg("Unable to access camera. Please allow camera and microphone permissions.");
    }
  };

  const stopCamera = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null;
      videoRef.current.onloadedmetadata = null;
    }
  };

  const startRecording = async () => {
    try {
      // First, try to get a list of video devices
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(device => device.kind === 'videoinput');

      // Try to find a device that doesn't contain "obs" in its label (if other devices exist)
      let preferredDeviceId = null;
      if (videoDevices.length > 1) {
        const realCameras = videoDevices.filter(device =>
          !device.label.toLowerCase().includes('obs') &&
          !device.label.toLowerCase().includes('virtual')
        );
        if (realCameras.length > 0) {
          preferredDeviceId = realCameras[0].deviceId;
        }
      }

      const constraints = {
        video: preferredDeviceId ? { deviceId: { exact: preferredDeviceId } } : {
          width: { ideal: 1280 },
          height: { ideal: 720 },
          facingMode: "user"
        },
        audio: true
      };

      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      streamRef.current = stream;
      setShowVideoPlaceholder(false);

      // Give React a tick to update the DOM
      setTimeout(() => {
        if (videoRef.current) {
          const videoElement = videoRef.current;
          videoElement.srcObject = stream;
          videoElement.play().catch(e => console.error("Error playing video:", e));

          const chunks = [];
          // Try to use video/mp4 if supported, otherwise fall back to browser default
          const mimeType = MediaRecorder.isTypeSupported('video/mp4') ? 'video/mp4' : 'video/webm';
          mediaRecorderRef.current = new MediaRecorder(stream, { mimeType });

          mediaRecorderRef.current.ondataavailable = (e) => {
            if (e.data.size > 0) {
              chunks.push(e.data);
            }
          };

          mediaRecorderRef.current.onstop = () => {
            const blob = new Blob(chunks, { type: mimeType });
            setVideoBlob(blob);
            setVideoUrl(URL.createObjectURL(blob));
            
            if (streamRef.current) {
              const tracks = streamRef.current.getTracks();
              tracks.forEach((track) => track.stop());
              streamRef.current = null;
            }
            if (videoRef.current) videoRef.current.srcObject = null;
            setIsRecording(false);
            if (timerRef.current) clearInterval(timerRef.current);
          };

          mediaRecorderRef.current.start();
          setIsRecording(true);
          setRecordingTime(0);

          if (timerRef.current) clearInterval(timerRef.current);
          timerRef.current = setInterval(() => {
            setRecordingTime((prev) => prev + 1);
          }, 1000);

          // Auto stop after 15 seconds
          setTimeout(() => {
            if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
              stopRecording();
            }
          }, 15000);
        }
      }, 50);
    } catch (err) {
      console.error("Error accessing camera:", err);
      setRequestSubmitError(true);
      setRequestSubmitErrorMsg("Unable to access camera. Please allow camera and microphone permissions.");
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
      mediaRecorderRef.current.stop();
    }
    setIsRecording(false);
  };

  const handleNavigateToPayout = () => {
    navigate('/payouts');
  }

  const handleFilterChange = (stepValue) => {
    setStepFilterValue(stepValue);
  }




  return (
    <>
      {!dataLoaded && <Loaders />}

      <Breadcrumb className="" breadcrumbIcon="WithdrawSvg" breadcrumbHeading="Request Payout" middleLink="/payouts" middleHeading="Payouts" />
      <div className="container-lg cl-custome3">
        <div className="common-box payouts-form-box">
          
            {/* --- Challenge Step 1 start  --- */}
            <div className={`common-box cb-all-none ${tab == "step1" ? '' : 'd-none'}`} id="step1">
              <CloseIcon className="ci-tr-0px" onClick={() => handleNavigateToPayout()} />
              <div className='common-box-heading'>Request Payout</div>
              <div className='common-section-separator'></div>
              <div className='common-box-text'>Use this form to request a new payout, we will verify and get in touch with you for further advancements</div>

              {/* trading account */}
              <div className="signinup-group mt-3">
                <div className="sg-list-bx">
                  <div className={`sg-list-item ${activeTab === 'trading_account' ? 'active' : ''}`} onClick={() => handleTabClick('trading_account')}>Trading Account</div>
                  <div className={`sg-list-item ${activeTab === 'affiliate' ? 'active' : ''}`} onClick={() => handleTabClick('affiliate')}>Affiliate</div>
                </div>
              </div>

              {activeTab === 'trading_account' && (
                <>
                  <div className="signinup-group">
                    <div className="sg-list-bx">
                      {(accountType && accountType.length > 0 && !isLoading) &&
                        accountType.map((stepAccountType, index) => (
                          <div className={"sg-list-item " + (stepFilterValue == stepAccountType.id ? "active" : '')} onClick={() => handleFilterChange(stepAccountType.id)}>{stepAccountType.step}</div>
                        ))
                      }
                    </div>
                  </div>

                  <div className="legal-content p-0">
                    <div className="legal-heading">
                      {(accountType.find(item => item.id == stepFilterValue)?.step?.toLowerCase().includes('instant') || accountType.find(item => item.id == stepFilterValue)?.name?.toLowerCase().includes('instant'))
                        ? 'Instant Payout Rules:'
                        : 'Note:'
                      }
                    </div>
                    <ul className="ul-dick">
                      {(accountType.find(item => item.id == stepFilterValue)?.step?.toLowerCase().includes('instant') || accountType.find(item => item.id == stepFilterValue)?.name?.toLowerCase().includes('instant')) ? (
                        <>
                          <li>Minimum 5 profitable trading days required</li>
                          <li>Profit split depends on your addon: On-Demand (60%), Weekly/Bi-Weekly (80%)</li>
                          <li>All trades must be closed before requesting payout</li>
                          <li>One pending request per account at a time</li>
                          <li>Payouts are processed within 24-48 hours</li>
                        </>
                      ) : (
                        <>
                          <li>Payouts can be requested on monthly basis.</li>
                          <li>ALL TRADES MUST BE CLOSED INCLUDING PENDING ORDERS.</li>
                          <li>Please wait for at least 15 mins after you close your latest trade to request a payout.</li>
                          <li>Minimum amount for an eligible payout is 1% of initial balance.</li>
                          <li>Payouts below $500 will be processed via crypto. Payouts above $500 will be processed via Bank transfer.</li>
                          <li>If Bank transfer does not support the country, the payout will be processed through crypto.</li>
                        </>
                      )}
                    </ul>
                  </div>

                  <div className='common-section-separator'></div>

                  

                  <div className='common-section-separator'></div>

                  <div className='col-12'>
                    <SelectInput heading="Choose Account" className="sgl-opacity1" defaultOption={'Select Account'} options={Accounttype} sglIcon='' value={selectedUserWalletID} onChange={handleUserWalletChange} errorMeg={errors?.selectedUserWalletID} error={errors?.selectedUserWalletID} />
                  </div>
                </>
              )}

              {activeTab === 'affiliate' && (
                <>
                {(affilateBalance < 100 && affilateBalance > 0) &&
                  <Alert
                    className="alert-style4 status-red2 aw-alert-bx"
                    icon="CurrencyDollar2Svg"
                    heading="Minimum amount of 100$ for affiliate withdrawal."
                  />
                } 

                {affilateBalance <= 0 &&
                  <Alert 
                    className="alert-style4 status-red2 aw-alert-bx"
                    icon="CurrencyDollar2Svg"
                    heading="You are not eligible for an affiliate payout yet"
                  />
                } 
              
                {/* {affilateBalance >= 100 &&  */}
                  <div className="affiliate-balance">
                    <div className="ab-name">Amount</div>
                    <div className="ab-balance">${affilateBalance}</div>
                  </div>
                {/* } */}
                </>
              )}

              {((affilateBalance >= 100 && activeTab == "affiliate") || (activeTab == "trading_account")) &&
                <div onClick={() => handleStepClick('step2')} className="common-submit-btn csb-width-full mb-0">Continue</div>
              }
            </div>
            {/* --- Challenge Step 1 end  --- */}


            {/* --- Challenge Step 2 start  --- */}
            <div className={`common-box cb-all-none ${inPaymentMethod == 0 && tab == "step2" ? '' : 'd-none'}`} id="step2">
              <div onClick={() => handleStepClick('step1')} className="common-back-btn cbb-absolute p-0"><Icons.ArrowBackSvg />Back</div>
              <div className='text-center cbh-16small mb-0"'>Choose payment method</div>
              <div className='common-section-separator'></div>
              <div className='row row-gap-3'>
                {paymentMethods && paymentMethods.map((option, index) => (
                  <PaymentMethodItem className="col-lg-4 col-sm-6 col-12" src={option.image_url} alt={option.name} heading={option.name} key={index} onClick={() => handlePaymentMethodIdChange(option.id, option.name)} />
                ))}
              </div>
            </div>
            {/* --- Challenge Step 2 end  --- */}


            {/* --- Challenge Step 3 start  --- */}
            <div className={`common-box cb-all-none ${inPaymentMethod != 0 && tab !== 'kyc_flow' ? '' : 'd-none'}`} id="step3">
              <div onClick={() => handleStepClick('step2')} className="common-back-btn cbb-absolute p-0"><Icons.ArrowBackSvg />Back</div>
              <div className='common-box-heading cbh-16small text-center mb-0'>Fill payout request</div>
              <div className='common-section-separator'></div>
            
              {(paymentMethodName != " " && paymentMethodName == "upi") &&
                <div className='row'>
                  {activeTab == "affiliate" &&
                    <div className="col-md-6 ">
                      <Input heading="Amount" type="number" placeholder="Enter amount" onChange={onChageAmount} value={amount} errorMeg={errors?.amount} error={errors?.amount} />
                    </div>
                  }

                  <div className="col-md-6">
                    <Input heading="Account Holder Name" type="text" placeholder="Enter Account Name" onChange={onChageAccountName} value={accountName} errorMeg={errors?.accountName} error={errors?.accountName} />
                  </div>

                  <div className="col-md-6">
                    <Input heading="Account Number" type="text" placeholder="Enter Account Number" onChange={onChageAccountNumber} value={accountNumber} errorMeg={errors?.accountNumber} error={errors?.accountNumber} />
                  </div>

                  <div className="col-md-6">
                    <Input heading="IFSC Code" type="text" placeholder="Enter IFSC Code" onChange={onChageIFSCCode} value={ifscCode} errorMeg={errors?.ifscCode} error={errors?.ifscCode} />
                  </div>

                  <div className="col-md-6">
                    <Input heading="Bank Name" type="text" placeholder="Enter Bank Name" onChange={onChageBankName} value={bankName} errorMeg={errors?.bankName} error={errors?.bankName} />
                  </div>
                </div>
              }

              {(paymentMethodName != " " && paymentMethodName != "upi") &&
                <div className='row'>
                  {activeTab == "affiliate" &&
                    <div className="col-md-6 ">
                      <Input heading="Amount" type="number" placeholder="Enter amount" onChange={onChageAmount} value={amount} errorMeg={errors?.amount} error={errors?.amount} />
                    </div>
                  }
                  <div className="col-md-6 ">
                    <Input heading="Withdraw Address" type="text" placeholder="Enter address id" onChange={onChageAddressID} value={addressID} errorMeg={errors?.addressID} error={errors?.addressID} />
                  </div>
                </div>
              }

              <div className="cfb-btn mt-2">
                {!isLoading && (
                  kycStatus === 'approved' ? (
                    <div className="common-submit-btn csb-width-full mb-0" onClick={handleAccountSubmit}>Submit Payout Request</div>
                  ) : (
                    <div className="common-submit-btn csb-width-full mb-0" onClick={() => setTab('kyc_flow')}>Continue to KYC</div>
                  )
                )}
                {isLoading && <div className="lsb-loader-btn csb-width-full mb-0"><img src={Img.loading} alt="" />Please wait ....</div>}
              </div>
            </div>
            {/* --- Challenge Step 3 end  --- */}

            {/* --- KYC Step start --- */}
            <div className={`common-box cb-all-none ${tab == "kyc_flow" ? '' : 'd-none'}`} id="kyc_flow">
              <div className="kyc-flow-box">
                <div onClick={() => setTab('step3')} className="common-back-btn cbb-absolute p-0"><Icons.ArrowBackSvg />Back</div>
                <div className="common-box-heading text-center">Complete Your KYC</div>
                <div className="kyc-steps-indicator text-center mt-3 mb-4">
                  <span className={`kyc-step-item ${kycStep === 'aadhar' ? 'active font-bold' : ''}`}>1. Aadhar Verification</span>
                  <span className={`kyc-step-item ms-4 ${kycStep === 'video' ? 'active font-bold' : ''}`}>2. Video KYC</span>
                </div>
                <div className="common-section-separator"></div>

                {kycStep === 'aadhar' && (
                  <div className="aadhar-verification-step">
                    <div className="kyc-step-title mb-2">Upload Aadhar Card</div>
                    <div className="kyc-step-desc mb-4">
                      Upload clear images of your Aadhar card (front and back). Your Aadhar name must match your Fundedskill username, otherwise your payout will be rejected.
                    </div>
                    
                    <Alert
                      className="alert-style4 status-yellow2 aw-alert-bx mb-4"
                      icon="InfoSvg"
                      heading="Important: Your Aadhar card name must match your Fundedskill user name. Ensure images are clear and readable for verification."
                    />

                    <div className="row g-4">
                      <div className="col-md-6">
                        <div className="upload-aadhar-box">
                          <label className="d-block mb-2">Aadhar Card - Front</label>
                          <div className="upload-preview-area text-center p-4 border-dashed rounded" onClick={() => document.getElementById('aadhar-front-input').click()}>
                            {aadharFrontPreview ? (
                              <img src={aadharFrontPreview} alt="Aadhar Front" className="img-fluid rounded" style={{ maxHeight: '200px' }} />
                            ) : (
                              <>
                                <Icons.UploadSvg className="size-12 mb-2 text-gray-400" />
                                <div className="upload-text">Click to upload Aadhar Front</div>
                                <div className="upload-hint text-xs text-gray-500">PNG, JPG (Max 5MB)</div>
                              </>
                            )}
                            <input type="file" id="aadhar-front-input" className="d-none" accept="image/*" onChange={handleAadharFrontChange} />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="upload-aadhar-box">
                          <label className="d-block mb-2">Aadhar Card - Back</label>
                          <div className="upload-preview-area text-center p-4 border-dashed rounded" onClick={() => document.getElementById('aadhar-back-input').click()}>
                            {aadharBackPreview ? (
                              <img src={aadharBackPreview} alt="Aadhar Back" className="img-fluid rounded" style={{ maxHeight: '200px' }} />
                            ) : (
                              <>
                                <Icons.UploadSvg className="size-12 mb-2 text-gray-400" />
                                <div className="upload-text">Click to upload Aadhar Back</div>
                                <div className="upload-hint text-xs text-gray-500">PNG, JPG (Max 5MB)</div>
                              </>
                            )}
                            <input type="file" id="aadhar-back-input" className="d-none" accept="image/*" onChange={handleAadharBackChange} />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="cfb-btn mt-5">
                      <div className={`common-submit-btn csb-width-full mb-0 ${(!aadharFront || !aadharBack) ? 'disabled opacity-50 cursor-not-allowed' : ''}`} onClick={() => { if(aadharFront && aadharBack) { setKycStep('video'); } }}>Upload Aadhar & Continue</div>
                    </div>
                  </div>
                )}

                {kycStep === 'video' && (
                  <div className="video-kyc-step">
                    <div className="kyc-step-title mb-2">Live Video KYC</div>
                    <div className="kyc-step-desc mb-4">
                      Record a live 10-15 second video for identity verification using your webcam.
                    </div>

                    {!videoBlob ? (
                      <div className="video-recording-area text-center">
                        <div className="video-container position-relative bg-black rounded overflow-hidden" style={{ minHeight: '300px', width: '100%', maxWidth: '500px', margin: '0 auto', border: '1px solid #333' }}>
                          <video 
                            key="kyc-live-video"
                            ref={videoRef} 
                            autoPlay 
                            playsInline 
                            muted 
                            className="w-100 h-100" 
                            style={{ objectFit: 'cover', background: '#000', minHeight: '300px', display: 'block' }}
                          ></video>
                          {isRecording && (
                            <div className="recording-indicator position-absolute top-0 start-0 m-3 d-flex align-items-center">
                              <span className="recording-dot me-2 bg-red-500 rounded-circle" style={{ width: '10px', height: '10px' }}></span>
                              <span className="text-white text-sm">Recording... {recordingTime}s</span>
                            </div>
                          )}
                          {!isRecording && (
                            <div className="video-instructions position-absolute bottom-0 start-0 w-100 p-3 bg-black bg-opacity-75 text-center">
                              <div className="text-white text-sm">
                                Say: "Hi Fundedskill, myself {state.userData?.first_name} {state.userData?.last_name} and I have applied for payout request." Hold your Aadhar card visibly.
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="cfb-btn mt-4">
                          {!isRecording ? (
                            <div className="common-submit-btn csb-width-full mb-0" onClick={startRecording}>Start Recording</div>
                          ) : (
                            <div className="common-submit-btn csb-width-full mb-0 bg-red-500" onClick={stopRecording}>Stop Recording</div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="video-preview-area text-center">
                        <div className="video-container bg-black rounded overflow-hidden" style={{ minHeight: '300px' }}>
                          <video src={videoUrl} controls className="w-100 h-100" style={{ objectFit: 'cover' }}></video>
                        </div>
                        <div className="row g-3 mt-4">
                          <div className="col-6">
                            <div className="common-submit-btn csb-width-full mb-0 bg-gray-500" onClick={() => { setVideoBlob(null); setVideoUrl(null); }}>Retake Video</div>
                          </div>
                          <div className="col-6">
                            {!isLoading ? (
                              <div className="common-submit-btn csb-width-full mb-0" onClick={handleAccountSubmit}>Submit Payout Request</div>
                            ) : (
                              <div className="lsb-loader-btn csb-width-full mb-0"><img src={Img.loading} alt="" />Submitting...</div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            {/* --- KYC Step end --- */}
        </div>
      </div>

      <FlashMessage type="success" isVisible={requestSubmitSuccess} message={requestSubmitSuccessMsg} />
      <FlashMessage type="error" isVisible={requestSubmitError} message={requestSubmitErrorMsg} />
    </>
  )
}
